<template>
  <div class="box-layout-chatbotBox">
    <template v-if="this.message.type === 'text'">
      <div class="flex">
        <img src="/static/img/assets/welcome/TypeText.svg" />
        <typography h6 :label="$t('ข้อความ')" :medium="true"></typography>
      </div>
      <div class="flex" style="justify-content: flex-end;gap:0px;">
        <img @click="openModal(message.type)" src="/static/img/assets/welcome/edit.svg" style="cursor: pointer;"/>
        <img @click="toggleDeleteMessage" src="/static/img/assets/welcome/delete.svg" style="cursor: pointer;" />
        <img @click="" src="/static/img/assets/welcome/Drag.svg" />
      </div>
      <v-dialog v-model="modalText">
        <div class="modal" style="height: 410px;width: 380px;" v-if="modalText">
          <div style="display:flex;flex-direction: row;justify-content: space-between;width:100%;">
            <typography h2 :label="$t('แก้ไขข้อความ')" :bold="true"></typography>
            <img
              src="/static/img/assets/welcome/X.svg"
              style="cursor: pointer;"
              class="close-icon"
              @click="closeModal(message.type)"
            />
          </div>
          <div>
            <div style="border: 1px solid #0C2F53;border-radius: 10px;height:110px;width:330px;">
              <textarea
                :value="textTitle"
                @input=";(textTitle = $event.target.value), isValid()"
                style="height:80px;width:322px; padding:14px;max-height: 80px;min-height: 80px;"
                class="text-area-focus"
                v-validate="'required'"
                name="ข้อความ"
                maxlength="2000"
                
              >
              </textarea>
              <div
                style="display: flex;justify-content: flex-end;margin-right: 12px;margin-bottom: 8px;color: #BDBDBD;font-weight: 500;font-size: 12px;"
              >
                {{ textTitle.length }}/2000
              </div>
            </div>
            <span class="text-error" v-if="errors.has('ข้อความ')">
              {{ errors.first('ข้อความ') }}
            </span>

            <div
              style="display: flex;flex-direction: row;margin-top: 16px;flex-wrap: wrap;gap:6px;"
            >
              <div
                class="tag-box"
                v-for="(item, index) in this.textRecommend"
                :key="'normal_question_' + index"
              >
                <div
                  style="display: flex;flex-direction: row;gap: 4px;align-items: center;justify-content: center;cursor: pointer;"
                  @click="textAddRecommend(item.value)"
                >
                  <div style="color:rgba(12, 47, 83, 1)">{{ item.title }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="hr-color" style="margin-top:16px;"></div>
          <div class="btn-footer">
            <v-btn class="btn-cancel" @click="closeModal(message.type)">
              ยกเลิก
            </v-btn>
            <v-btn class="btn-summit" @click="addMessage(message.type)">
              ยืนยัน
            </v-btn>
          </div>
        </div>
      </v-dialog>
    </template>
    <template v-if="this.message.type === 'button'">
      <div class="flex">
        <img src="/static/img/assets/welcome/TypeButton.svg" />
        <typography h6 :label="$t('ปุ่มกด')" :medium="true"></typography>
      </div>
      <div class="flex" style="justify-content: flex-end;gap:0px;">
        <img @click="openModal(message.type)" src="/static/img/assets/welcome/edit.svg" style="cursor: pointer;" />
        <img @click="toggleDeleteMessage" src="/static/img/assets/welcome/delete.svg" style="cursor: pointer;" />
        <img @click="" src="/static/img/assets/welcome/Drag.svg" />
      </div>
      <v-dialog v-model="modalButton">
        <div class="modal" style="height: 410px;width: 380px;" v-if="modalButton">
          <div style="display:flex;flex-direction: row;justify-content: space-between;width:100%;">
            <typography h2 :label="$t('แก้ไขปุ่มกด')" :bold="true"></typography>
            <img
              src="/static/img/assets/welcome/X.svg"
              class="close-icon"
              style="cursor: pointer;"
              @click="closeModal(message.type)"
            />
          </div>
          <div style="display: flex;flex-direction: column;align-items: center;">
            <div
              style="display:flex;flex-direction: row;align-items: center;gap:4px;border: 1px solid #0C2F53;border-radius: 10px;height:40px;width:330px;"
            >
              <input
                v-model="buttonTitle"
                maxlength="20"
                style="height:40px;width:300px; margin-left: 14px;margin-bottom: 0px;"
                class="input-focus"
                placeholder="กรุณาใส่ข้อความ"
              />
              <div
                style="display: flex;justify-content: flex-end;margin-right: 12px;color: #BDBDBD;font-weight: 500;font-size: 12px;"
              >
                {{ buttonTitle.length }}/20
              </div>
            </div>
            <div
              style="display: flex;flex-direction: column;align-items: center;justify-content: center;gap:4px; margin-top: 16px;"
            >
              <template v-for="(data, index) in this.buttonButton">
                <div class="button-editButton">
                  <template v-if="buttonEditButton[index]">
                    <input
                      v-model="data.title"
                      class="input-focus"
                      style="color:#fff;font-weight: 700;font-size: 16px; "
                    />
                    <img
                      src="/static/img/assets/welcome/correct-white.svg"
                      style="width:20px;height: 20px;cursor: pointer;"
                      @click="buttonChangeEditButton(index)"
                    />
                  </template>
                  <template v-else>
                    <div style="color: #FFFFFF;font-weight: 700;font-size: 16px;width:100%;">
                      {{ data.title }}
                    </div>

                    <img
                      src="/static/img/assets/welcome/pencil-white.svg"
                      style="width:20px;height: 20px;cursor: pointer;"
                      @click="buttonChangeEditButton(index)"
                    />
                  </template>
                  <img
                    src="/static/img/assets/welcome/bin-white.svg"
                    style="width:20px;height: 20px;cursor: pointer;"
                    @click="buttonDeleteButton(index)"
                  />
                </div>
              </template>
              <template v-if="buttonButton.length < 3"> 
                <div class="button-addButton" @click="buttonAddButton">
                  <img
                    src="/static/img/assets/welcome/plus-gray.svg"
                    style="width:20px;height: 20px;"
                  />
                  <div style="color: #BDBDBD;font-weight: 700;font-size: 16px;">
                    เพิ่มปุ่มกด
                  </div>
                </div>
              </template>
            </div>
            <div
              style="display: flex;flex-direction: column;align-items: center;justify-content: center;gap:4px; margin-top: 16px;"
            >
              <div style="display:flex;flex-direction: row;justify-content: flex-start;width:100%;">
                <div style="font-weight: 600;font-size: 16px;color: #2C2C2C;">ตั้งค่าปุ่มกด</div>
              </div>
              <template v-for="(data, index) in this.buttonButton">
                <div
                  style="display: flex;flex-direction: column;align-items: center;justify-content: center; margin-top: 16px;"
                >
                  <div class="button-settingButtonTop">
                    {{ data.title }}
                  </div>
                  <div class="button-settingButtonBotton">
                    <v-select
                      v-model="data.type"
                      placeholder="แคมเปญ"
                      :items="buttonType"
                      item-text="name"
                      item-value="type"
                      hide-details
                      dense
                      outline
                      append-icon="mdi-chevron-down"
                      class="button-select"
                      :prepend-inner-icon="buttonTypeIcon(index)"
                    >
                    </v-select>

                    <template v-if="data.type === 'web_url'">
                      <div style="font-weight: 500;font-size: 14px;color: #818181;">
                        *หากลูกค้ากดปุ่มนี้ บอทจะพาลูกค้าไปสู่ลิ้งค์นี้
                      </div>
                      <div>
                        <div style="color: #2C2C2C;font-weight: 600;font-size: 16px;">
                          ลิ้งค์
                        </div>
                        <input
                          v-model="data.url"
                          class="button-inputButtonType"
                          placeholder="http://www.example.com"
                        />
                      </div>
                    </template>
                    <template v-if="data.type === 'postback'">
                      <div style="font-weight: 500;font-size: 14px;color: #818181;">
                        *หากลูกค้ากดปุ่มนี้ บอทจะตอบกลับลูกค้า (คุณสามารถแก้ไขคำตอบในหน้า
                        conversation)
                      </div>
                      <div>
                        <div style="color: #2C2C2C;font-weight: 600;font-size: 16px;">
                          Action
                        </div>
                        <input v-model="data.payload" class="button-inputButtonType" />
                      </div>
                    </template>
                    <template v-if="data.type === 'phone_number'">
                      <div style="font-weight: 500;font-size: 14px;color: #818181;">
                        *หากลูกค้ากดปุ่มนี้ บอทจะโทรออกอัตโนมัติตามเบอร์ที่กรอกไว้
                        (ฟังก์ชันนี้ใช้ได้เมื่อลูกค้าใช้มือถือในการเชื่อมต่อเท่านั้น)
                      </div>
                      <div>
                        <div style="color: #2C2C2C;font-weight: 600;font-size: 16px;">
                          Action
                        </div>
                        <input v-model="data.payload" class="button-inputButtonType" />
                      </div>
                    </template>
                    <template v-if="data.type === 'broadcast'">
                      <div>
                        <v-radio-group v-model="data.payload" row>
                          <!-- <v-radio
                                                  v-for="item in this.buttonBroadcastType"
                                                  :key="item.name"
                                                  :label="`${item.type}`"
                                                  :value="item.type"
                                                  color="rgba(12, 47, 83, 1)"
                                                  ></v-radio> -->
                          <v-radio
                            label="สมัครรับข่าวสาร"
                            value="subscribeBroadcast"
                            color="rgba(12, 47, 83, 1)"
                            background-color="#fff"
                          ></v-radio>
                          <v-radio
                            label="ยกเลิกรับข่าวสาร"
                            value="unsubscribeBroadcast"
                            color="rgba(12, 47, 83, 1)"
                          ></v-radio>
                        </v-radio-group>
                      </div>
                    </template>
                  </div>
                </div>
              </template>
            </div>
          </div>
          <div class="hr-color" style="margin-top:16px;"></div>
          <div class="btn-footer">
            <v-btn class="btn-cancel" @click="closeModal(message.type)">
              ยกเลิก
            </v-btn>
            <v-btn class="btn-summit" @click="addMessage(message.type)">
              ยืนยัน
            </v-btn>
          </div>
        </div>
      </v-dialog>
    </template>
    <template v-if="this.message.type === 'image'">
      <div class="flex">
        <img src="/static/img/assets/welcome/TypeImage.svg" />
        <typography h6 :label="$t('รูปภาพ')" :medium="true"></typography>
      </div>
      <div class="flex" style="justify-content: flex-end;gap:0px;">
        <img @click="openModal(message.type)" src="/static/img/assets/welcome/edit.svg" style="cursor: pointer;" />
        <img @click="toggleDeleteMessage" src="/static/img/assets/welcome/delete.svg" style="cursor: pointer;" />
        <img @click="" src="/static/img/assets/welcome/Drag.svg" />
      </div>
      <v-dialog v-model="modalImage">
        <div class="modal" style="height: 480px;width: 380px;" v-if="modalImage">
          <div style="display:flex;flex-direction: row;justify-content: space-between;width:100%;">
            <typography h2 :label="$t('แก้ไขรูปภาพ')" :bold="true"></typography>
            <img
              src="/static/img/assets/welcome/X.svg"
              class="close-icon"
              style="cursor: pointer;"
              @click="closeModal(message.type)"
            />
          </div>

          <div>
            <div
              :ref="'answer_' + (intent_index - 1) + '_' + intent_index"
              class="message"
              style="float:left; position:relative; border-radius: 12px;height: 246px;
                  width: 328px; overflow-wrap: break-word; min-height: 22px; min-width: 14px; line-height: 15.36px; overflow: hidden;margin-top: 40px; "
            >
              <uploadfile
                ref="answer"
                v-model="image_url"
                :height="246"
                data-vv-as="Image"
                :data-vv-name="'answer_' + (intent_index - 1) + '_image_' + intent_index"
                v-validate
              ></uploadfile>
            </div>
            <div class="clearfix"></div>
          </div>

          <div class="hr-color" style="margin-top:16px;"></div>

          <div class="btn-footer">
            <v-btn class="btn-cancel" @click="closeModal(message.type)">
              ยกเลิก
            </v-btn>
            <v-btn class="btn-summit" @click="addMessage(message.type)">
              ยืนยัน
            </v-btn>
          </div>
        </div>
      </v-dialog>
    </template>
    <template v-if="this.message.type === 'video'">
      <div class="flex">
        <img src="/static/img/assets/welcome/TypeVideo.svg" />
        <typography h6 :label="$t('วีดิโอ')" :medium="true"></typography>
      </div>
      <div class="flex" style="justify-content: flex-end;gap:0px;">
        <img @click="openModal(message.type)" src="/static/img/assets/welcome/edit.svg" style="cursor: pointer;" />
        <img @click="toggleDeleteMessage" src="/static/img/assets/welcome/delete.svg" style="cursor: pointer;" />
        <img @click="" src="/static/img/assets/welcome/Drag.svg" />
      </div>
      <v-dialog v-model="modalVideo">
        <div class="modal" style="width: 380px;" v-if="modalVideo">
          <div style="display:flex;flex-direction: row;justify-content: space-between;width:100%;">
            <typography h2 :label="$t('แก้ไขวีดิโอ')" :bold="true"></typography>
            <img
              src="/static/img/assets/welcome/X.svg"
              class="close-icon"
              style="cursor: pointer;"
              @click="closeModal(message.type)"
            />
          </div>

          <div style="display:flex; flex-direction: column; justify-content: flex-start; ">
            <v-radio-group v-model="videoType" row>
              <v-radio
                v-for="item in this.videoCheckType"
                :key="item.name"
                :label="`${item.name}`"
                :value="item.type"
                color="rgba(12, 47, 83, 1)"
              ></v-radio>
            </v-radio-group>
            <template v-if="videoType === 'upload'">
              <div
                :ref="'answer_' + (intent_index - 1) + '_' + intent_index"
                class="message"
                style="float:left; position:relative; border-radius: 12px;height: 246px;width: 328px; overflow-wrap: break-word; min-height: 22px; min-width: 14px; line-height: 15.36px; overflow: hidden; "
              >
                <uploadVideo v-model="upload_url"> </uploadVideo>
              </div>
            </template>
            <template v-if="videoType === 'link_url'">
              <div
                style="display:flex;flex-direction: row;align-items: center;gap:4px;border: 1px solid #0C2F53;border-radius: 10px;height:40px;width:330px;"
              >
                <input
                  v-model="video_url"
                  style="height:40px;width:300px; margin-left: 14px;margin-bottom: 0px;"
                  class="input-focus"
                  placeholder="กรุณาใส่ข้อความ"
                />
                
              </div>
            </template>
            <div class="clearfix"></div>
          </div>

          <div class="hr-color" style="margin-top:16px;"></div>

          <div class="btn-footer">
            <v-btn class="btn-cancel" @click="closeModal(message.type)">
              ยกเลิก
            </v-btn>
            <v-btn class="btn-summit" @click="addMessage(message.type)">
              ยืนยัน
            </v-btn>
          </div>
        </div>
      </v-dialog>
    </template>
    <template v-if="this.message.type === 'generic'">
      <div class="flex">
        <img src="/static/img/assets/welcome/TypeListMenu.svg" />
        <typography h6 :label="$t('ลิสต์เมนู')" :medium="true"></typography>
      </div>
      <div class="flex" style="justify-content: flex-end;gap:0px;">
        <img @click="openModal(message.type)" src="/static/img/assets/welcome/edit.svg" style="cursor: pointer;" />
        <img @click="toggleDeleteMessage" src="/static/img/assets/welcome/delete.svg" style="cursor: pointer;" />
        <img @click="" src="/static/img/assets/welcome/Drag.svg" />
      </div>
      <v-dialog v-model="modalGeneric">
        <div class="modal" style="height: 640px;width: 440px;" v-if="modalGeneric">
          <div style="display:flex;flex-direction: row;justify-content: space-between;width:100%;">
            <typography h2 :label="$t('แก้ไขลิสต์เมนู')" :bold="true"></typography>
            <img
              src="/static/img/assets/welcome/X.svg"
              class="close-icon"
              style="cursor: pointer;"
              @click="closeModal(message.type)"
            />
          </div>
          <div style="width: 100%;margin-top: 40px;">
            <div style="width: 100%;">
              <carousel
                :navigationEnabled="true"
                :paginationEnabled="false"
                :perPage="1"
                v-model="genericButtonIndex"
                ref="carousel"
              >
              
                <slide v-for="(data, index) in this.genericData" :key="`card-${index}`">
                  <div class="generic-Card">
                    <div style="width: 100%;position: relative;">
                      
                      <template v-if="genericData.length > 1">
                        <img src="/static/img/assets/welcome/DeleteGeneric.svg" style="z-index:100;position: absolute; top:-10px;left:-10px;cursor: pointer;"
                        @click="deleteGenericCard(index)"
                        />
                      </template>
                      <uploadfile
                        ref="answer"
                        v-model="data.image_url"
                        :height="246"
                        data-vv-as="Image"
                        :data-vv-name="'answer_' + (index - 1) + '_image_' + index"
                        v-validate
                        :borderTopRightRadius="15"
                        :borderTopLeftRadius="15"
                      ></uploadfile>
                    </div>
                    <div style="display: flex;flex-direction: column;justify-content: center;">
                      <input
                        v-model="data.title"
                        style="width:220px; margin-bottom: 6px;"
                        class="input-focus"
                        placeholder="กรุณาใส่ข้อความ"
                      />
                      <input
                        v-model="data.subtitle"
                        style="width:220px; margin-bottom: 6px;"
                        class="input-focus"
                        placeholder="กรุณาใส่ข้อความ"
                      />
                      <div
                        style="display:flex;flex-direction: column;gap:10px; justify-content: center;align-items: center;"
                      >
                     
                        <template v-for="(item, idx) in (data.buttons || [])">
                          <div class="button-editButton">
                            <template v-if="genericEditButton[index][idx]">
                              <input
                                v-model="item.title"
                                class="input-focus"
                                style="color:#fff;font-weight: 700;font-size: 16px; "
                                maxlength="20"
                              />
                              <img
                                src="/static/img/assets/welcome/correct-white.svg"
                                style="width:20px;height: 20px;cursor: pointer;"
                                @click="genericChangeEditButton(index, idx)"
                              />
                            </template>
                            <template v-else>
                              <div
                                style="color: #FFFFFF;font-weight: 700;font-size: 16px;width:100%;"
                              >
                                {{ item.title }}
                              </div>

                              <img
                                src="/static/img/assets/welcome/pencil-white.svg"
                                style="width:20px;height: 20px;cursor: pointer;"
                                @click="genericChangeEditButton(index, idx)"
                              />
                            </template>
                            <img
                              src="/static/img/assets/welcome/bin-white.svg"
                              style="width:20px;height: 20px;cursor: pointer;"
                              @click="genericDeleteButton(index, idx)"
                            />
                          </div>
                        </template>

                        <template v-if="_get(data, `buttons`, []).length < 3"> 
                          <div class="button-addButton" @click="genericAddButton(index)">
                            <img
                              src="/static/img/assets/welcome/plus-gray.svg"
                              style="width:20px;height: 20px;"
                            />
                            <div style="color: #BDBDBD;font-weight: 700;font-size: 16px;">
                              เพิ่มปุ่มกด
                            </div>
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                </slide>
              
              </carousel>
              <div
                style="margin-top:30px;display:flex;justify-content: flex-end;align-items: end;gap:8px;"
              >
                <div v-for="(data, index) in genericData" :key="`pagination-${key}`">
                  <template v-if="index === genericButtonIndex">
                        <div class="box">
                            <div style="color: #0C2F53;font-weight: 400;font-size: 14px; cursor: default;">{{ index + 1 }}</div> 
                        </div>
                    </template>
                    <template v-else>
                        <div v-on:click="genericChangeCarousel(index)" 
                        style="width: 32px !important; height: 32px !important; border-radius: 5px !important; background: #FFFFFF !important; border: 1px solid #BDBDBD !important; display: flex; justify-content: center; align-items: center;cursor: pointer;" >
                          <div style="color: #BDBDBD;font-weight: 400;font-size: 14px; cursor: pointer;">{{ index + 1 }}</div>    
                        </div>
                    </template>
                </div>
                <template v-if="(genericData || []).length < 10">
                  <div
                    style="width: 32px !important; height: 32px !important; border-radius: 5px !important; background: #FFFFFF !important; border: 1px solid #BDBDBD !important; display: flex; justify-content: center; align-items: center;cursor: pointer;"
                    @click="genericAddContent()"
                  >
                    <div style="color: #BDBDBD;font-weight: 400;font-size: 14px;">+</div>
                  </div>
                </template>
              </div>
            </div>

            <div
              style="display: flex;flex-direction: column;align-items: center;justify-content: center;gap:4px; margin-top: 16px;"
            >
              <div style="display:flex;flex-direction: row;justify-content: flex-start;width:100%;">
                <div style="font-weight: 600;font-size: 16px;color: #2C2C2C;">ตั้งค่าปุ่มกด</div>
              </div>

              <template v-if="genericButtonIndex < genericData.length">
                <template v-for="(data, index) in _get(genericData, `[${genericButtonIndex}].buttons`, [])">
                  <div
                    style="display: flex;flex-direction: column;align-items: center;justify-content: center; margin-top: 16px;"
                  >
                    <div class="button-settingButtonTop">
                      {{ data.title }} 
                    </div>
                    <div class="button-settingButtonBotton">
                      <v-select
                        v-model="data.type"
                        placeholder="แคมเปญ"
                        :items="buttonType"
                        item-text="name"
                        item-value="type"
                        hide-details
                        dense
                        outline
                        append-icon="mdi-chevron-down"
                        class="button-select"
                        :prepend-inner-icon="genericTypeIcon(index)" 
                      >
                      </v-select>
                      <template v-if="data.type === 'web_url'">
                        <div style="font-weight: 500;font-size: 14px;color: #818181;">
                          *หากลูกค้ากดปุ่มนี้ บอทจะพาลูกค้าไปสู่ลิ้งค์นี้
                        </div>
                        <div>
                          <div style="color: #2C2C2C;font-weight: 600;font-size: 16px;">
                            ลิ้งค์
                          </div>
                          <input
                            v-model="data.url"
                            class="button-inputButtonType"
                            placeholder="http://www.example.com"
                          />
                        </div>
                      </template>
                      <template v-if="data.type === 'postback'">
                        <div style="font-weight: 500;font-size: 14px;color: #818181;">
                          *หากลูกค้ากดปุ่มนี้ บอทจะตอบกลับลูกค้า (คุณสามารถแก้ไขคำตอบในหน้า
                          conversation)
                        </div>
                        <div>
                          <div style="color: #2C2C2C;font-weight: 600;font-size: 16px;">
                            Action
                          </div>
                          <input v-model="data.payload" class="button-inputButtonType" />
                        </div>
                      </template>
                      <template v-if="data.type === 'phone_number'">
                        <div style="font-weight: 500;font-size: 14px;color: #818181;">
                          *หากลูกค้ากดปุ่มนี้ บอทจะโทรออกอัตโนมัติตามเบอร์ที่กรอกไว้
                          (ฟังก์ชันนี้ใช้ได้เมื่อลูกค้าใช้มือถือในการเชื่อมต่อเท่านั้น)
                        </div>
                        <div>
                          <div style="color: #2C2C2C;font-weight: 600;font-size: 16px;">
                            Action
                          </div>
                          <input v-model="data.payload" class="button-inputButtonType" />
                        </div>
                      </template>
                      <template v-if="data.type === 'broadcast'">
                        <div>
                          <v-radio-group v-model="data.payload" row>
                            <!-- <v-radio
                                                    v-for="item in this.buttonBroadcastType"
                                                    :key="item.name"
                                                    :label="`${item.type}`"
                                                    :value="item.type"
                                                    color="rgba(12, 47, 83, 1)"
                                                    ></v-radio> -->
                            <v-radio
                              label="สมัครรับข่าวสาร"
                              value="subscribeBroadcast"
                              color="rgba(12, 47, 83, 1)"
                            ></v-radio>
                            <v-radio
                              label="ยกเลิกรับข่าวสาร"
                              value="unsubscribeBroadcast"
                              color="rgba(12, 47, 83, 1)"
                            ></v-radio>
                          </v-radio-group>
                        </div>
                      </template>
                    </div>
                  </div>
                </template>
              </template>
              

            </div>
          </div>
          <div class="hr-color" style="margin-top:16px;"></div>
          <div class="btn-footer">
            <v-btn class="btn-cancel" @click="closeModal(message.type)">
              ยกเลิก
            </v-btn>
            <v-btn class="btn-summit" @click="addMessage(message.type)">
              ยืนยัน
            </v-btn>
          </div>
        </div>
      </v-dialog>
    </template>
    <template v-if="this.message.type === 'flex'">
      <div class="flex">
        <img src="/static/img/assets/welcome/TypeFlexMessage.svg" />
        <typography h6 :label="$t('Flex Message')" :medium="true"></typography>
      </div>
      <div class="flex" style="justify-content: flex-end;gap:0px;">
        <img @click="openModal(message.type)" src="/static/img/assets/welcome/edit.svg" style="cursor: pointer;" />
        <img @click="toggleDeleteMessage" src="/static/img/assets/welcome/delete.svg" style="cursor: pointer;" />
        <img @click="" src="/static/img/assets/welcome/Drag.svg" />
      </div>
      <v-dialog v-model="modalFlex">
        <div class="modal" v-if="modalFlex">
          <div style="display:flex;flex-direction: row;justify-content: space-between;width:100%;">
            <typography h2 :label="$t('แก้ไข Flex Message')" :bold="true"></typography>
            <img
              src="/static/img/assets/welcome/X.svg"
              class="close-icon"
              style="cursor: pointer;"
              @click="closeModal(message.type)"
            />
          </div>
          <div style="width:100%;margin-top: 40px;">
            {
            <br />
            <span class="pl-5">type: flex,</span>
            <br />
            <span class="pl-5">contents:</span>
            <br />
            <div class="pl-5">
              <codemirror ref="cmCode" v-model="flexContents" :options="cmOptions"></codemirror>
            </div>

            <br />
            }
            <br />
          </div>
          <div class="hr-color" style="margin-top:16px;"></div>
          <div class="btn-footer">
            <v-btn class="btn-cancel" @click="closeModal(message.type)">
              ยกเลิก
            </v-btn>
            <v-btn class="btn-summit" @click="addMessage(message.type)">
              ยืนยัน
            </v-btn>
          </div>
        </div>
      </v-dialog>
    </template>
    <template v-if="this.message.type === 'sticker'">
      <div class="flex">
        <img src="/static/img/assets/welcome/TypeLineSticker.svg" />
        <typography h6 :label="$t('Line Sticker')" :medium="true"></typography>
      </div>
      <div class="flex" style="justify-content: flex-end;gap:0px;">
        <img @click="openModal(message.type)" src="/static/img/assets/welcome/edit.svg" style="cursor: pointer;" />
        <img @click="toggleDeleteMessage" src="/static/img/assets/welcome/delete.svg" style="cursor: pointer;" />
        <img @click="" src="/static/img/assets/welcome/Drag.svg" />
      </div>
      <v-dialog v-model="modalSticker">
        <div class="modal" style="height: 820px;width: 600px;" v-if="modalSticker">
          <div style="display:flex;flex-direction: row;justify-content: space-between;width:100%;">
            <typography h2 :label="$t('แก้ไข Sticker')" :bold="true"></typography>
            <img
              src="/static/img/assets/welcome/X.svg"
              class="close-icon"
              style="cursor: pointer;"
              @click="closeModal(message.type)"
            />
          </div>
          <div style="width:100%;margin-top: 40px;">
            <div>
              <v-divider></v-divider>
              <v-layout>
                <template v-for="(sticker, index) in stickers">
                  <v-flex
                    style="max-width: 50px; border-right: 1px solid #eee"
                    :class="{ primary: currentPackage == index }"
                    @click="currentPackage = index"
                  >
                    <div class="py-1 px-2">
                      <v-img
                        aspect-ratio="1"
                        :src="`/static/img/assets/stickers/${index}/${sticker[0]}.png`"
                        style="height:30px;width:30px;"
                      ></v-img>
                    </div>
                  </v-flex>
                </template>
              </v-layout>
              <v-divider></v-divider>
            </div>
            <v-card-text style="max-height: 600px">
              <v-layout wrap>
                <v-flex
                  xs3
                  sm2
                  class="pa-1 sticker"
                  v-for="(sticker, index) in stickers[currentPackage]"
                  :key="`sticker_${index}`"
                  style="cursor: pointer;"
                  @click="addSticker(currentPackage, sticker)"
                >
                  <v-img
                    aspect-ratio="1"
                    :src="`/static/img/assets/stickers/${currentPackage}/${sticker}.png`"
                    style=""
                  ></v-img>
                </v-flex>
              </v-layout>
            </v-card-text>
          </div>
          <div class="hr-color" style="margin-top:16px;"></div>
          <!-- <div class="btn-footer">
                <v-btn class="btn-cancel" @click="closeModal(data.type)">
                  ยกเลิก
                </v-btn>
                <v-btn class="btn-summit" @click="addMessage(data.type)">
                  ยืนยัน
                </v-btn>
              </div> -->
        </div>
      </v-dialog>
    </template>

    <v-dialog v-model="modalDelete" persistent width="400px">
          <v-card style="border-radius: 10px" v-if="modalDelete">
            <div class="pa-3">
              <div style="display:flex;flex-direction: row;justify-content: flex-end;width:100%;">
          <img
            src="/static/img/assets/welcome/X.svg"
            class="close-icon"
            @click="toggleDeleteMessage"
          />
        </div>
        <div style="display: flex;flex-direction: column;align-items: center;gap:24px;">
          <img src="/static/img/assets/welcome/delete.svg" style="width:63px;height:63px;" />
          <div style="font-weight: 700;font-size: 16px;color: #0C2F53;">
            คุณต้องการลบโมดูลนี้ใช่หรือไม่
          </div>
        </div>
              <div class="rsu">
                <v-layout row wrap>
                  <v-flex xs12 class="mb-2 mt-2 pr-1">

                  </v-flex>
                </v-layout>
                <div style="display: flex; justify-content: center">
                  <Button
                    outline
                    :label="$t('cancel')"
                    @click="toggleDeleteMessage()"
                  />
                  <Button
                    depressed
                    :label="$t('Save')"
                    @click="summitDeleteMessage()"
                  />
                </div>
              </div>
            </div>
          </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Typography from '../../elements/Typography.vue'
import Button from '../../elements/Button.vue'
import api from '@/api'
import uploadfile from '@/components/elements/uploadfile'
import uploadVideo from '@/components/elements/uploadvideo'
import { Carousel, Slide } from 'vue-carousel'
import { codemirror } from 'vue-codemirror'
import DropdownMenu from '@/components/elements/DropdownMenu.vue'
import _ from 'lodash'
export default {
  components: {
    Typography,
    Button,
    uploadfile,
    Carousel,
    Slide,
    codemirror,
    DropdownMenu,
    uploadVideo
  },
  data: function() {
    return {
      modalDelete: false,
      bubbleMessages: [],
      messages: [],
      modalText: false,
      textTitle: '',
      textRecommend: [
        {
          value: '{first_name}',
          title: 'ชื่อจริง'
        },
        {
          value: '{last_name}',
          title: 'นามสกุล'
        },
        {
          value: '{status}',
          title: 'สถานะ'
        },
        {
          value: '{tag}',
          title: 'ป้ายกำกับ'
        },
        {
          value: '{msg}',
          title: 'ข้อความ'
        },
        {
          value: '{session.default={msg}}',
          title: 'เซสชั่น'
        }
      ],
      modalButton: false,
      buttonTitle: '',
      buttonEditButton: [false],
      buttonButton: [
        {
          title: 'ชื่อปุ่ม',
          type: 'web_url',
          url: '',
          payload: ''
        }
      ],
      buttonType: [
        { name: 'ลิ้งค์', type: 'web_url', icon: 'mdi-link' },
        { name: 'ข้อความ', type: 'postback', icon: 'mdi-text' },
        { name: 'เบอร์โทร', type: 'phone_number', icon: 'mdi-phone' },
        { name: 'บรอดแคสต์', type: 'broadcast', icon: 'mdi-broadcast' }
      ],
      buttonBroadcastType: [
        { name: 'สมัครรับข่าวสาร', type: 'subscribeBroadcast' },
        { name: 'ยกเลิกรับข่าวสาร', type: 'unsubscribeBroadcast' }
      ],
      modalImage: false,
      image_url: '',
      modalVideo: false,
      videoType: 'upload',
      upload_url: '',
      video_url: '',
      videoCheckType: [
        { name: 'อัปโหลดวีดิโอ', type: 'upload' },
        { name: 'แนบลิ้งค์ URL', type: 'link_url' }
      ],

      modalGeneric: false,
      genericData: [
        {
          image_url: '',
          title: '',
          subtitle: '',
          buttons: [
            {
              title: 'ชื่อปุ่ม',
              type: 'web_url',
              url: '',
              payload: ''
            }
          ],
          default_action: {
            type: 'web_url',
            url: ''
          }
        }
      ],
      genericEditButton: [[false]],
      genericButtonIndex: 0,

      modalFlex: false,
      flexContents: '',
      cmOptions: {
        // codemirror options
        tabSize: 4,
        mode: {
          name: 'javascript',
          json: true
        },
        showCursorWhenSelecting: true,
        matchBrackets: true,
        styleSelectedText: true,
        styleActiveLine: true,
        theme: 'base16-light',
        lineNumbers: true,
        line: true,
        autoFocus: true,
        autoRefresh: true
        // more codemirror options, 更多 codemirror 的高级配置...
      },
      modalSticker: false,
      packageid: '',
      stickerid: '',
      currentPackage: 11537,
      stickers: {
        '11537': [
          52002734,
          52002735,
          52002736,
          52002737,
          52002738,
          52002739,
          52002740,
          52002741,
          52002742,
          52002743,
          52002744,
          52002745,
          52002746,
          52002747,
          52002748,
          52002749,
          52002750,
          52002751,
          52002752,
          52002753,
          52002754,
          52002755,
          52002756,
          52002757,
          52002758,
          52002759,
          52002760,
          52002761,
          52002762,
          52002763,
          52002764,
          52002765,
          52002766,
          52002767,
          52002768,
          52002769,
          52002770,
          52002771,
          52002772,
          52002773
        ],
        '11538': [
          51626497,
          51626494,
          51626495,
          51626496,
          51626498,
          51626499,
          51626500,
          51626501,
          51626502,
          51626503,
          51626504,
          51626505,
          51626506,
          51626507,
          51626508,
          51626509,
          51626510,
          51626511,
          51626512,
          51626513,
          51626514,
          51626515,
          51626516,
          51626517,
          51626518,
          51626519,
          51626520,
          51626521,
          51626522,
          51626523,
          51626524,
          51626525,
          51626526,
          51626527,
          51626528,
          51626529,
          51626530,
          51626531,
          51626532,
          51626533
        ],
        '11539': [
          52114113,
          52114110,
          52114111,
          52114112,
          52114114,
          52114115,
          52114116,
          52114117,
          52114118,
          52114119,
          52114120,
          52114121,
          52114122,
          52114123,
          52114124,
          52114125,
          52114126,
          52114127,
          52114128,
          52114129,
          52114130,
          52114131,
          52114132,
          52114133,
          52114134,
          52114135,
          52114136,
          52114137,
          52114138,
          52114139,
          52114140,
          52114141,
          52114142,
          52114143,
          52114144,
          52114145,
          52114146,
          52114147,
          52114148,
          52114149
        ]
      }
    }
  },
  props: {
    message: Object,
    keyIndex: Number,
    intent_index: Number, //index ที่เลือกอยู่
    answers: Array,
    type: String
  },
  mounted: function() {

  },
  watch: {
    message: {
      deep: true,
      immediate: true,
      handler(message) {
        if (message.type === 'text') {
          this.textTitle = message.text
        } else if (message.type === 'button') {
          this.buttonTitle = message.text
          this.buttonButton = message.buttons
        } else if (message.type === 'image') {
          this.image_url = message.image_url
        } else if (message.type === 'video') {
          const regex = /^https:\/\/api\.minio\.techunt-dev\.witsawa\.com\//;
          if(regex.test(message.source)) {
            this.upload_url = message.source
          } else {
            this.video_url = message.source
            this.videoType = 'link_url'
          }
           
        } else if (message.type === 'generic') {
          this.genericData = _.cloneDeep(message.data)
          let editArray = []
          this.genericData.map((item, index) => {
            editArray.push([])
            item.buttons.map((item, idx)=>{
              editArray[index].push(false)
            })
          })
          this.genericEditButton = editArray
          this.$forceUpdate()
        } else if (message.type === 'flex') {
          this.flexContents = message.contents
        } else if (message.type === 'sticker') {
        }
      }
    }
  },
  methods: {
    _get: _.get,
    openModal: function(type) {
      if (type === 'text') {
        this.modalText = true
      } else if (type === 'button') {
        this.modalButton = true
      } else if (type === 'image') {
        this.modalImage = true
      } else if (type === 'video') {
        this.modalVideo = true
      } else if (type === 'generic') {
        this.modalGeneric = true
      } else if (type === 'flex') {
        this.modalFlex = true
      } else if (type === 'sticker') {
        this.modalSticker = true
      }
    },
    closeModal: function(type) {
      if (type === 'text') {
        this.modalText = false
       // this.textTitle = ''
      } else if (type === 'button') {
        this.modalButton = false
        // this.buttonTitle = ''
        // ;(this.buttonEditButton = [false]),
        //   (this.buttonButton = [
        //     {
        //       title: 'ชื่อปุ่ม',
        //       type: 'web_url',
        //       url: '',
        //       payload: ''
        //     }
        //   ])
      } else if (type === 'image') {
        this.modalImage = false
       // this.image_url = ''
      } else if (type === 'video') {
        this.modalVideo = false
        // this.videoType = 'upload'
        // this.upload_url = ''
        // this.video_url = ''
      } else if (type === 'generic') {
        this.modalGeneric = false
        // this.genericData = [
        //   {
        //     image_url: '',
        //     title: '',
        //     subtitle: '',
        //     buttons: [
        //       {
        //         title: 'ชื่อปุ่ม',
        //         type: 'web_url',
        //         url: '',
        //         payload: ''
        //       }
        //     ],
        //     default_action: {
        //       type: 'web_url',
        //       url: ''
        //     }
        //   }
        // ]
        // this.genericEditButton = [[false]]
        // this.genericButtonIndex = 0

      } else if (type === 'flex') {
        this.modalFlex = false
      //  this.flexContents = ''
      } else if (type === 'sticker') {
        this.modalSticker = false
        this.packageid = ''
        this.stickerid = ''
      }
    },
    addIntentItem: function(type, data) {
      var vm = this

      if (type == 'text') {
        if (this.textTitle === '') {
          this.closeModal(this.message.type)
        }
        this.answers[this.intent_index].splice(this.keyIndex, 1, {
          text: this.textTitle,
          type: type
        })
      } else if (type == 'button') {
        const newButton = []
        this.buttonButton.map(item => {
          if (item.type === 'web_url') {
            delete item.payload
          } else {
            delete item.url
          }
          newButton.push(item)
        })
        this.answers[this.intent_index].splice(this.keyIndex, 1, {
          text: this.buttonTitle,
          buttons: newButton,
          type: type
        })
      } else if (type == 'image') {
        this.answers[this.intent_index].splice(this.keyIndex, 1, {
          image_url: this.image_url,
          type: type
        })
      } else if (type == 'video') {
        this.answers[this.intent_index].splice(this.keyIndex, 1, {
          type: type,
          source: this.videoType === 'upload' ? this.upload_url : this.video_url ,
          picture: null,
          sourceline: this.videoType === 'upload' ? this.upload_url : this.video_url
        })
      } else if (type == 'generic') {
        this.genericData.map(item => {
          item.buttons.map(button => {
            if (button.type === 'web_url') {
              delete button.payload
            } else {
              delete button.url
            }
            if (button.type === 'broadcast'){
              if( button.payload === ''){
                button.payload = 'subscribeBroadcast'
              }
            }
          })
        })
        this.answers[this.intent_index].splice(this.keyIndex, 1, {
          data: this.genericData,
          type: type
        })
      } else if (type === 'flex') {
        this.answers[this.intent_index].splice(this.keyIndex, 1, {
          type: type,
          altText: 'You received a message',
          contents: this.flexContents
        })
      } else if (type === 'sticker') {
        this.answers[this.intent_index].splice(this.keyIndex, 1, {
          type: type,
          packageid: this.packageid,
          stickerid: this.stickerid
        })
      }
    },
    saveWelcomeMessage: function() {
      let vm = this
      let data = {
        pageid: vm.$store.state.selectedBot.pageid,
        type: 'json'
      }
      vm.$store.dispatch('loading')

      var messages = []
      data['message'] = JSON.stringify(this.answers)
      console.log('this.answers',this.answers)
      api.saveWelcomeMessage(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
          return
        }
        vm.cached_type = vm.type
        vm.cached_messages = JSON.stringify(messages)
        vm.bubbleMessages = messages
        vm.$store.dispatch('updateWelcomeMessage', {
          type: 'json',
          message: null,
          generics: null,
          messages: messages
        })

        vm.isEditWelcome = false
        vm.$store.dispatch('loading')
        if (response) {
          vm.$emit('getWelcomeMessage')
          vm.$swal.fire({
            type: 'success',
            title: '<div class="headline primary--text bold7 fs-24">บันทึกข้อมูลสำเร็จ</div>',
            confirmButtonText: '<span style="color:#FFEF01">ปิด</span>',
          })
        }
      })
    },
    async addMessage() {
      this.addIntentItem(this.type)
      this.saveWelcomeMessage()
      this.closeModal(this.type)
    },
    async isValid() {
      let isValid = await this.$validator.validate()
      if (isValid) {
        return
      }
    },
    textAddRecommend: function(value) {
      this.textTitle = this.textTitle + value
    },
    buttonAddButton: function() {
      this.buttonButton.push({
        title: 'ปุ่ม',
        type: 'web_url',
        url: ''
      })
      this.buttonEditButton.push(false)
    },
    buttonDeleteButton: function(index) {
      this.buttonButton.splice(index, 1)
      this.buttonEditButton.splice(index, 1)
    },
    buttonChangeEditButton: function(index) {
      this.buttonEditButton[index] = !this.buttonEditButton[index]
      this.$forceUpdate()
    },
    genericAddContent: function() {
      this.genericData.push({
        image_url: '',
        title: '',
        subtitle: '',
        buttons: [
          {
            title: 'ชื่อปุ่ม',
            type: 'web_url',
            url: '',
            payload: ''
          }
        ],
        default_action: {
          type: 'web_url',
          url: ''
        }
      })
      this.genericEditButton.push([false])
      this.$forceUpdate()
    },
    deleteGenericCard: function(index){
      this.genericData.splice(index, 1)
      this.genericButtonIndex = (index - 1) < 0 ? 0 : index - 1
      this.$forceUpdate()
    },
    genericAddButton: function(index) {
      if(this.genericData[index].buttons){
        this.genericData[index].buttons.push({
          title: 'ชื่อปุ่ม',
          type: 'web_url',
          url: '',
          payload: ''
        })
        this.genericEditButton[index].push(false)
      }
      this.$forceUpdate()
    },
    genericDeleteButton: function(index, idx) {
      this.genericData[index].buttons.splice(idx, 1)
      this.genericEditButton[index].splice(idx, 1)
      this.$forceUpdate()
    },
    genericChangeEditButton: function(index, idx) {
      this.genericEditButton[index][idx] = !this.genericEditButton[index][idx]
      this.$forceUpdate()
    },
    genericChangeCarousel: function(index) {
      this.genericButtonIndex = index
      this.$forceUpdate()
    },
    async addSticker(packageid, stickerid) {
      var result = await this.$swal.fire({
        title: `<img src="/static/img/assets/stickers/${packageid}/${stickerid}.png" style="max-height: 150px">`,
        text: this.$t('Do you want to send this sticker?'),
        showCancelButton: true,
        confirmButtonText: '<span style="font-weight: 700;font-size: 16px;color:#FFEF01">ยืนยัน</span>',
        cancelButtonText: '<span style="font-weight: 700;font-size: 16px;color: #0C2F53;">ยกเลิก</span>',
        reverseButtons: true
      })
      if (result.value) {
        this.packageid = packageid
        this.stickerid = stickerid
        this.addMessage()
      }
    },
    toggleDeleteMessage: function() {
      this.modalDelete = !this.modalDelete
    },
    summitDeleteMessage: function() {
      let vm = this
      if( this.answers.length === 1 && this.answers[this.intent_index].length === 1  ){
        this.$swal.fire({
        title:'<div style="color:background: rgba(12, 47, 83, 1);"> เกิดข้อผิดพลาด </div>',
        html: `<div> ไม่สามารถลบได้ (จำเป็นต้องมีอย่างน้อย 1 รายการ) </div>`,
        showCancelButton: false,
        showCloseButton: true,
        confirmButtonText: '<span style="color:#FFEF01">ปิด</span>',
        width:'590px',
        })
        this.modalDelete = false
        return
      }
      this.answers[this.intent_index].splice(this.keyIndex, 1)
      if(this.answers[this.intent_index].length === 0){
        this.answers.splice(this.intent_index, 1)
        vm.$emit('changIntentIndex',this.answers.length - 1)
      }
      this.saveWelcomeMessage()
      vm.$forceUpdate()
      this.modalDelete = false
    },
    buttonTypeIcon: function(index) {
      let icon = this.buttonType.map(item => {
        if (this.buttonButton[index].type === item.type) {
          return item.icon
        }
      })
      return icon
    },
    genericTypeIcon: function(index) {
      let icon = this.buttonType.map(item => {
        if (this.genericData[this.genericButtonIndex].buttons[index].type === item.type) {
          return item.icon
        }
        // if(_get(genericData, `[${genericButtonIndex}].buttons[${index}].type`, '') === item.type){
        //   console.log('_get(genericData, `[${genericButtonIndex}].buttons[${index}].type`, )')
        //   return item.icon
        // }
      })
      return icon
    },
  },
}
</script>
<style lang="scss" scoped>
.box-layout-chatbotBox {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px 12px;
  width: 241px;
  height: 40px;
  background: #ffffff;
  border: 1px solid #0c2f53;
  border-radius: 10px;
}
.flex {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
}
.box {
  width: 32px !important;
  height: 32px !important;
  border-radius: 5px !important;
  /* background: #FFFFFF !important; */
  border: 1px solid #0c2f53 !important;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.box-addChatbot {
  width: 100px !important;
  height: 80px !important;
  border-radius: 10px !important;
  background: #ffffff !important;
  border: 1px solid #0c2f53 !important;
  padding-top: 12px;
  cursor: default;
}
.box-addChatbot:hover {
  width: 100px !important;
  height: 80px !important;
  border-radius: 10px !important;
  background: rgba(230, 240, 251, 1) !important;
  border: 1px solid #0c2f53 !important;
  padding-top: 12px;
}
.box-addChatbot-disable {
  width: 100px !important;
  height: 80px !important;
  background: #ffffff !important;
  padding-top: 12px !important;
  border: 1px dashed #0c2f53 !important;
  border-radius: 10px !important;
  cursor: default;
  opacity: 0.5;
}

.flex-addChatbot {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.modal {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 30px 26px 30px 26px;
  position: fixed;
  top: 40px;
  overflow-x: hidden;
  border-radius: 10px;
}

.v-overlay--active {
  backdrop-filter: blur(2px) !important;
  background: rgba(0, 0, 0, 0.87) !important;
  opacity: 1 !important;
}
.v-overlay::before {
  opacity: 1 !important;
}
.btn-footer {
  display: flex;
  flex-direction: row;
  gap: 14px;
}
.btn-summit {
  background: #0c2f53 !important;
  border-radius: 6px;
  width: 142px;
  height: 38px;
  color: #ffef01 !important;
  font-weight: 700;
  font-size: 16px;
}
.btn-cancel {
  background: #ffffff !important;
  border: 1px solid #0c2f53;
  border-radius: 6px;
  width: 142px;
  height: 38px;
  color: #0c2f53 !important;
  font-weight: 700;
  font-size: 16px;
}
.tag-box {
  /* background-color: red; */
  background-color: #fff;
  padding: 0px 8px 0px 8px;
  display: inline-block;
  margin-right: 8px;
  /* margin-bottom: 8px; */
  border: 1px solid rgba(12, 47, 83, 1);
  color: #fff;
  border-radius: 6px;
  min-width: 60px;
  text-align: center;
  justify-content: center;
  height: 25px;
  cursor: default;
}
.tag-box:hover {
  background-color: rgba(230, 240, 251, 1);
}
.close-icon {
  position: relative;
  top: -10px;
  right: -10px;
  width: 24px;
  height: 24px;
}
.text-area-focus:focus-visible {
  outline: none;
}
.flex-text-area {
  border: 1px solid #9e9e9e;
}
.text-error {
  color: red;
}
.input-focus {
  border-bottom: 0px solid #9e9e9e;
  border: none !important;
  outline: none;
  margin: 0px;
  font-family: 'Sukhumvit Set' !important;
}
.input-focus:focus {
  border-bottom: 0px solid #9e9e9e;
  border: none !important;
  outline: none;
  box-shadow: 0 0px 0 0 #000 !important;
}
.button-editButton {
  background: linear-gradient(274.72deg, #0c2f53 7.12%, #26588b 99.76%);
  border-radius: 5px;
  width: 188px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 16px;
  padding-right: 16px;
}
.button-addButton {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border: 1px dashed #bdbdbd;
  border-radius: 5px;
  width: 188px;
  height: 40px;
  cursor: pointer;
}
.button-settingButtonTop {
  background: linear-gradient(274.72deg, #0c2f53 7.12%, #26588b 99.76%);
  border-radius: 8px 8px 0px 0px;
  width: 328px;
  height: 40px;
  color: #ffffff;
  font-weight: 700;
  font-size: 16px;
  padding-left: 26px;
  display: flex;
  align-items: center;
}
.button-settingButtonBotton {
  background: #e6f0fb;
  border-radius: 0px 0px 8px 8px;
  width: 328px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.button-select {
  background: #ffffff;
  border: 0px solid #2c2c2c !important;
  border-radius: 0px !important;
  //height: 38px;
  outline: none;
  padding-top: 0px !important;
  margin-top: 0px !important;
}
.v-select.v-text-field--enclosed:not(.v-text-field--single-line) .v-select__selections {
  padding-top: 0px !important;
}
.button-inputButtonType {
  height: 37px;
  width: 282px;
  background: #ffffff;
  border: 1px solid #0c2f53;
  border-radius: 6px;
  padding-left: 14px;
  color: #0c2f53;
  outline: none;
  box-shadow: none !important;
}
.generic-Card {
  width: 241px;
  min-height: 363px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 0px;
  padding-bottom: 10px;
  margin-top: 10px;
  margin-right: 20px;
  margin-left: 30px;
  background: #ffffff;
  border: 1px solid #eeeeee;
  box-shadow: 4px 2px 5px rgba(0, 0, 0, 0.1);
  border-radius: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/welcomemessage/ChatbotBox.vue